import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../St/Reports/UseStyle';
//=====================================================================
import { useTranslation } from "react-i18next";
import { useStylesContainers } from '../../../St/comps/UseStyle';
import { Button, ButtonBase, colors } from '@material-ui/core';

export default function AnnualSuscriptionBegin(props) {

    const {
        AutoOptions,
        changTField,
        params,
        valueAutos,
        changAutos,
        handOpenScreen,
        passwordScreen,
        setPasswordScreen
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();


    const clsConts = useStylesContainers();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);

    const [showPic, setShowPic] = useState(false);
    return (
        <React.Fragment>
            <Grid container justifyContent="center" spacing={2}>
                <Grid
                    item
                    container
                    spacing={1}
                    // justifyContent='center'
                    lg={12} md={12} sm={12} xs={12}
                >
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Autocomplete
                            classes={clasAo}
                            value={valueAutos.branch}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                changAutos("branch", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Branches}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:branch")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameA"

                            label={t("organization-name-ar")}
                            //className={clasTF.clrBlack}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                            // InputProps={{ className: clasTD.input, readOnly: true }}
                            type="text"
                            name="nameA"
                            value={params.nameA}

                            onChange={changTField("nameA")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameE"
                            label={t("organization-name-en")}
                            type="text"
                            name="nameE"
                            value={params.nameE}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                            onChange={changTField("nameE")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="FieldA"
                            label={t("password")}
                            type="password"
                            name="FieldA"
                            value={passwordScreen}
                            autoComplete='new-password'
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,
                            }}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                form: {
                                    autoComplete: 'off'
                                }
                            }}
                            onChange={changTField("password")}
                        />
                    </Grid>
                    <br />
                    <br />
                    <br />
                    <br />

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Button
                            fullWidth
                            autoFocus
                            variant="contained"
                            color="primary"
                            className={clasTF.rootSaleOil}
                            // onClick={handOpenScreen}
                            onClick={(event) => handOpenScreen(event)}

                            style={{
                                background: "#49B3A7",
                                ...{
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                },
                            }}
                        //startIcon={<ArrowDownwardIcon />}
                        >
                            {t("open")}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>



        </React.Fragment>
    );

}